import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails, SortGrid } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetClientTravelsCheckingAccountCommand extends IRequestCommand<
  IGetClientTravelsCAResponse,
  ErrorDetails,
  IGetClientTravelsCACommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  public setUrlParameters(clientId: number, sorting: SortGrid): void {
    this.urlSections.push('passengers');
    this.urlSections.push(`${clientId}`);
    this.urlSections.push('travelsCheckingAccount');
    this.urlSections.push('paginated');
    this.paramsSections.push(`page=${sorting.page}`);
    this.paramsSections.push(`size=${sorting.size}`);
    this.paramsSections.push(`column=${sorting.column}`);
    this.paramsSections.push(`sort=${sorting.sort}`);
    this.composeUrl();
  }
}

export interface IGetClientTravelsCACommandParameters
  extends ICommandParameters {}

export interface IGetClientTravelsCAResponse extends ICommandResponse {}
